import { createRootRoute, createRoute } from '@tanstack/react-router';
import RootLayout from '@phrmpc/app/layouts/RootLayout';
import NavigationLayout from '@phrmpc/app/layouts/NavigationLayout';
import AuthenticatedLayout from '@phrmpc/app/layouts/AuthenticatedLayout';
import PlaceholderPage from '@phrmpc/shared/components/PlaceholderPage';

export const rootRoute = createRootRoute({
  component: RootLayout,
});

export const protectedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: '_protected',
  component: NavigationLayout,
});

export const appRoute = createRoute({
  getParentRoute: () => protectedRoute,
  id: '_app',
  component: AuthenticatedLayout,
});